/**
 * Injects the Google Analytics (GA4) gtag.js snippet and initializes tracking for the given Measurement ID.
 * Relies on GA4's Enhanced Measurement (page_view on history changes) to auto-capture pageviews across routes.
 */
export function loadGoogleAnalytics(measurementId: string): void {
  const loaderScript = document.createElement("script");
  loaderScript.async = true;
  loaderScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(loaderScript);

  const configScript = document.createElement("script");
  configScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${measurementId}');
  `;
  document.head.appendChild(configScript);
}
